export default __webpack_public_path__ + "static/media/bg-landing.53e57d74.svg";